import Button, { ButtonProps } from '@material-ui/core/Button'
import React from 'react'
import styled, { css } from 'styled-components'

import hexToRgba from '../../lib/HexToRgba'
import TrackedButton from '../tracking/TrackedButton'

export type ActionButtonVariant = 'secondaryFill' | 'secondaryOutline'

export type ActionGroupItem = {
  children: string
  className?: string
  tracking?: {
    action: string
    category: string
    label: string
  }
  url: string
  variant?: ActionButtonVariant
}

const BaseActionButton = ({ children, url, tracking, className }: ActionGroupItem) => {
  const buttonProps: ButtonProps = {
    classes: { root: className },
    href: url,
    variant: 'contained',
  }

  if (tracking) {
    return (
      <TrackedButton {...buttonProps} tracking={tracking}>
        {children}
      </TrackedButton>
    )
  }

  return <Button {...buttonProps}>{children}</Button>
}

const ActionButton = styled(BaseActionButton)`
  ${({ variant = 'secondaryFill', theme: { spacing, palette, breakpoints } }) => css`
    border: 2px solid;
    border-radius: 0;
    ${variant === 'secondaryFill' &&
    css`
      background-color: ${palette.secondary.main};
      border-color: ${palette.secondary.main};
      color: ${palette.common.white};
      margin-bottom: ${spacing(2)}px;
      ${breakpoints.up('md')} {
        margin-bottom: 0;
      }
      &:hover,
      &:focus {
        background-color: ${hexToRgba(palette.secondary.main, 0.8)};
        border-color: ${hexToRgba(palette.secondary.main, 0.8)};
        color: ${palette.common.white};
      }
    `}
    ${variant === 'secondaryOutline' &&
    css`
      background-color: ${palette.common.white};
      border-color: ${palette.secondary.main};
      color: ${palette.secondary.main};
      &:hover,
      &:focus {
        background-color: ${palette.secondary.main};
        color: ${palette.common.white};
      }
      ${breakpoints.up('md')} {
        margin: ${spacing(0, 2, 0, 0)};
      }
    `}
  `}
`

export default ActionButton
